import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import { router } from "../router/index";
import {
  setLocalStorage,
  clearLocalStorage,
  setLocalStorageNewTokenKey,
  setLocalStorageExpiredStatus,
} from "../js/oauth";
import { setSnackBarInfo } from "../js/common_function";
import { eventBus } from "../main.js";

const AXIOS = axios.create({
  baseURL: "/api",
  timeout: 20000,
});

const state = {
  searchResults: [],
  currentIndex: -1,
  num: {
    previous: "",
    next: "",
  },
  reply: [],
  thisId: "",
  editWarningMsg: "",
  radioSelectedView: false,
  replyOk: false,
  modal: {
    open: false,
    title: "",
    content: "",
    option1: "",
    option2: "",
    result: "",
  },
  detail: {
    open: false,
    title: "",
    content: "",
    option1: "",
    option2: "",
    result: "",
  },

  edit: {
    id: "",
    title: "",
    contents: "",
    auth: "",
    open: false,
    new: false,
    editable: false,
    editableUse: false,
    sort: "",
    remained: false,
    memberType: "",
    notice: false,
  },
};

const getters = {
  isPrevious(state) {
    if (state.currentIndex > 0) {
      return state.searchResults[state.currentIndex - 1].id;
    }
    return null;
  },
  isNext(state) {
    if (state.currentIndex < state.searchResults.length - 1) {
      return state.searchResults[state.currentIndex + 1].id;
    }
    return null;
  },
  isPrevious(state) {
    return state.num.previous;
  },
  isNext(state) {
    return state.num.next;
  },
  isContentsAuth(state) {
    return state.edit.auth;
  },
  isContentsNotice(state) {
    return state.edit.notice;
  },
  isId(state) {
    return state.edit.id;
  },
  isTitle(state) {
    return state.edit.title;
  },
  isContents(state) {
    return state.edit.contents;
  },
  isMemberType(state) {
    return state.edit.memberType;
  },
  isNew(state) {
    return state.edit.new;
  },
  isRemained(state) {
    return state.edit.remained;
  },
  isEditable(state) {
    return state.edit.editable;
  },
  isEditableUse(state) {
    return state.edit.editableUse;
  },
  isRadioSelectedView(state) {
    return state.radioSelectedView;
  },
  isSort(state) {
    return state.edit.sort;
  },
  isReply(state) {
    return state.reply;
  },
  isThisId(state) {
    return state.thisId;
  },
  isReplyOk(state) {
    return state.replyOk;
  },
  isEnd(state) {
    return state.edit.end;
  },
};

const mutations = {
  SET_SEARCH_RESULTS(state, results) {
    state.searchResults = results;
  },
  SET_CURRENT_INDEX(state, index) {
    state.currentIndex = index;
  },
  PREV_NEXT_NUM(state, Nm) {
    state.num.previous = Nm.previous;
    state.num.next = Nm.next;
  },
  SET_EDIT_WARNINGMSG(state, msg) {
    state.editWarningMsg = msg;
  },
  SET_REPLY(state, data) {
    state.reply = data;
  },
  SET_THISID(state, data) {
    state.thisId = data;
  },
  CLOSE_MODAL(state) {
    state.modal.open = false;
  },
  EDIT_MODAL(state) {
    state.edit.editable = true;
    state.edit.editableUse = false;
    if (state.edit.sort === "privateBulletinBoard") {
      state.radioSelectedView = false;
    } else {
      state.radioSelectedView = true;
    }
  },
  EDIT_DETAIL(state) {
    state.edit.editable = true;
    state.edit.editableUse = false;
    if (state.edit.sort === "privateBulletinBoard") {
      state.radioSelectedView = false;
    } else {
      state.radioSelectedView = true;
    }
  },
  EDIT_DETAIL_CANCEL(state) {
    state.edit.editable = false;
    state.edit.editableUse = true;
    if (state.edit.sort === "privateBulletinBoard") {
      state.radioSelectedView = false;
    } else {
      state.radioSelectedView = true;
    }
  },
  OPEN_MODAL(state, title) {
    state.loadingState = false;
    state.modal.title = title;
    state.editWarningMsg = "";
    state.modal.open = true;
    this.commit("END_SPINNER");
  },
  ADD_CONTENTS(state, contents) {
    state.edit.id = contents.id;
    state.edit.open = contents.open;
    state.edit.title = contents.title;
    state.edit.contents = contents.contentsHTML;
    state.edit.auth = contents.auth;
    state.edit.notice = contents.notice;
    state.edit.editable = contents.editable;
    state.edit.editableUse = contents.editableUse;
    state.edit.sort = contents.sort;
    state.edit.memberType = contents.memberType;
    state.replyOk = contents.replyUse;
    state.radioSelectedView = contents.radioSelectedView;
    state.edit.new = contents.isNew;
    state.edit.remained = contents.remained;
  },
  NEW_CONTENTS(state, contents) {
    state.edit.new = contents.isNew;
    state.edit.open = contents.open;
    state.edit.editable = contents.editable;
    state.edit.editableUse = contents.editableUse;
    state.edit.sort = contents.sort;
    state.edit.notice = contents.notice;
    state.replyOk = contents.replyUse;
    state.edit.auth = contents.auth;
    state.radioSelectedView = contents.radioSelectedView;
  },
  DEL_CONTENTS(state) {
    state.edit.id = "";
    state.edit.title = "";
    state.edit.contents = "";
    state.edit.auth = "";
    state.edit.editable = "";
    state.edit.editableUse = "";
    state.edit.sort = "";
    state.edit.notice = false;
    state.replyOk = "";
    state.radioSelectedView = "";
    state.edit.memberType = "";
  },
  SET_MEMBER_TYPE(state, contents) {
    state.edit.memberType = contents;
  },
};

function bulletin_save(contents) {
  return AXIOS({
    url: "/bulletin/saveBulletinList",
    method: "post",
    data: {
      id: contents.id,
      title: contents.title,
      contentsHTML: contents.contents,
      auth: contents.auth,
      notice: contents.notice,
      contents: contents.contents.replace(/<[^>]*>/g, ""),
      sort: contents.sort,
    },
    headers: {
      "token-key": localStorage.getItem("token-key"),
      "token-setup": localStorage.getItem("token-setup"),
    },
    timeout: 20000,
  });
}

function private_bulletin_save(contents) {
  return AXIOS({
    url: "/bulletin/saveBulletinList",
    method: "post",
    data: {
      id: contents.id,
      title: contents.title,
      contentsHTML: contents.contents,
      auth: "viewPrivate",
      contents: contents.contents.replace(/<[^>]*>/g, ""),
      sort: contents.sort,
    },
    headers: {
      "token-key": localStorage.getItem("token-key"),
      "token-setup": localStorage.getItem("token-setup"),
    },
    timeout: 20000,
  });
}

function visitorsbook_save(contents) {
  return AXIOS({
    url: "/visitorsBook/saveVisitorsBook",
    url: "/visitorsBook/saveVisitorsBook",
    method: "post",
    data: {
      id: contents.id,
      title: contents.title,
      auth: contents.auth,
      contentsHTML: contents.contents,
      contents: contents.contents.replace(/<[^>]*>/g, ""),
      sort: contents.sort,
    },
    timeout: 20000,
  });
}

function bulletin_delete(contents) {
  return AXIOS({
    url: "/bulletin/deleteBulletinList",
    method: "post",
    data: {
      id: contents.id,
      sort: contents.sort,
    },
    headers: {
      "token-key": localStorage.getItem("token-key"),
    },
  });
}

function add_bulletn_count(contents) {
  return AXIOS({
    url: "/bulletin/addBulletinCount",
    method: "post",
    data: {
      id: contents.id,
      sort: contents.sort,
    },
    headers: {
      "token-key": localStorage.getItem("token-key"),
    },
  });
}

function add_visitorsbook_count(contents) {
  return AXIOS({
    url: "/visitorsBook/addVisitorsBookCount",
    method: "post",
    data: {
      id: contents.id,
      sort: contents.sort,
    },
    headers: {
      "token-key": localStorage.getItem("token-key"),
    },
  });
}

function create_reply(newItems) {
  return AXIOS({
    url: "/bulletin/createReply",
    method: "post",
    data: {
      refId: newItems.refId,
      contents: newItems.contents,
    },
    headers: {
      "token-key": localStorage.getItem("token-key"),
    },
  });
}

function delete_reply(newItems) {
  return AXIOS({
    url: "/bulletin/deleteReply",
    method: "post",
    data: {
      id: newItems.id,
      refId: newItems.refId,
    },
    headers: {
      "token-key": localStorage.getItem("token-key"),
    },
  });
}
function privateBulletinBoardCheck(contents) {
  return AXIOS({
    url: "/privateBulletinBoardCheck",
    method: "post",
    data: {
      refId: contents.id,
    },
    headers: {
      "token-key": localStorage.getItem("token-key"),
    },
  });
}

function getReply(contents) {
  return AXIOS({
    url: "/getReply",
    method: "post",
    data: {
      refId: contents.id,
      sort: contents.sort,
    },
    headers: {
      "token-key": localStorage.getItem("token-key"),
    },
  });
}
function check_memberType() {
  return AXIOS({
    url: "/bulletin/checkNewContentsMemberType",
    method: "post",
    data: {},
    headers: {
      "token-key": localStorage.getItem("token-key"),
    },
  }).then((res) => {
    return res;
  });
}

const actions = {
  setSearchResults({ commit }, results) {
    commit('SET_SEARCH_RESULTS', results);
  },
  setCurrentIndex({ commit }, index) {
    commit('SET_CURRENT_INDEX', index);
  },
  async BULLETIN_SAVE(context, contents) {
    try {
      var result = "";
      switch (contents.sort) {
        case "bulletinBoard":
          result = await bulletin_save(contents);
          break;
        case "privateBulletinBoard":
          if (contents.username !== "operinto@naver.com") {
            const res = await privateBulletinBoardCheck(contents);
          }
          // console.log(res);
          result = await private_bulletin_save(contents);
          break;
        case "visitorsBook":
          result = await visitorsbook_save(contents);
          break;
        default:
          result = await bulletin_save(contents);
          break;
      }

      if (result.data.statusCode === 200) {
        context.commit(
          "SET_SNACKBAR",
          setSnackBarInfo("저장이 완료되었습니다.")
        );
        return true;
      } else {
        return false;
      }
    } catch (e) {
      console.log(e);
      context.commit("SET_SNACKBAR", setSnackBarInfo("저장 실패."));
      return false;
    }
  },
  async BULLETIN_DELETE(context, contents) {
    try {
      const response = await bulletin_delete(contents);
      context.commit("SET_SNACKBAR", setSnackBarInfo("삭제가 완료되었습니다."));
      // setTimeout(function() {
      //   location.reload();
      // }, 1000);
      return response;
    } catch (e) {
      console.log(e);
      context.commit("SET_SNACKBAR", setSnackBarInfo("삭제 실패."));
    }
  },
  async CHECK_NEW_CONTENTS_MEMBERTYPE(context) {
    try {
      const response = await check_memberType();
      context.commit("SET_MEMBER_TYPE", response.data.memberType);
      return true;
    } catch (e) {
      console.log(e);
      context.commit("SET_SNACKBAR", setSnackBarInfo("멤버타입 조회 실패."));
      return false;
    }
  },
  async ADD_BULLETIN_COUNT(context, contents) {
    try {
      switch (contents.sort) {
        case "bulletinBoard":
          add_bulletn_count(contents);
          break;
        case "privateBulletinBoard":
          add_bulletn_count(contents);
          break;
        case "visitorsBook":
          add_visitorsbook_count(contents);
          break;
        default:
          add_bulletn_count(contents);
          break;
      }
      // context.commit('SET_SNACKBAR', setSnackBarInfo('삭제가 완료되었습니다.'));
      // setTimeout(function() {
      //   location.reload();
      // }, 1000);
      // return response;
    } catch (e) {
      console.log(e);
    }
  },
  async CREATE_REPLY(context, newItems) {
    try {
      const response = await create_reply(newItems);
      return response;
    } catch (e) {
      console.log(e);
    }
  },
  async DELETE_REPLY(context, newItems) {
    try {
      const response = await delete_reply(newItems);
      return response;
    } catch (e) {
      console.log(e);
    }
  },
  async SET_BULLETIN(context, contents) {
    try {
      if (contents.isNew) {
        context.commit("ADD_CONTENTS", contents);
        return true;
      } else {
        context.commit("ADD_CONTENTS", contents);
        context.commit("SET_THISID", contents.id);
        const response = await getReply(contents);
        if (response.status === 200) {
          context.commit("SET_REPLY", response.data);
          context.dispatch("ADD_BULLETIN_COUNT", contents);
          return true;
        } else {
          context.commit("SET_SNACKBAR", setSnackBarInfo("조회 실패."));
          return false;
        }
      }
    } catch (e) {
      console.log(e);
      return false;
    }
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
